import React, { useContext } from 'react';

import { Box, Typography } from '@mui/material';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import PlaySmallIcon from '../../assets/icons/PlaySmallIcon';
import { UserInfoCtx } from '../../containers/CommonLayout/CommonLayout';
import { DEFAULT_URL } from '../../pages/DiscoverPage/const';
import { BREAKPOINTS_VALUES, colorsPalette } from '../../theme';
import { VideoCategory, VideoDifficulty } from '../../types';
import { createCategoryLink, secondsToHms } from '../../utils/helpers';
import useToggleFromWatchlist from '../../utils/hooks/useToggleFromWatchlist';
import { CardDurationInfo } from '../Card';
import IKImage from '../IKImage/IKImage';
import ToggleFromList from '../ToggleFromList/ToggleFromList';
import { CategoryLabel } from '../UI/CategoryLabel';
import DifficultyIcon from '../UI/DifficultyIcon';
import useStyles from './styles';

interface SideVideoCardProps {
  id?: string | null;
  title?: string | null;
  author?: string | null;
  duration?: number | null;
  previewUrl?: string | null;
  videoUrl?: string | null;
  categories?: (VideoCategory | null)[] | null;
  link: string;
  difficulty?: VideoDifficulty | null;
  authorSlug?: string | null;
  wrapperClass?: string;
  isInWatchlist: boolean;
}

const SideVideoCard: React.FC<SideVideoCardProps> = ({
  id,
  title,
  author,
  duration,
  previewUrl,
  categories,
  link,
  difficulty,
  authorSlug,
  wrapperClass,
  isInWatchlist,
  ...rest
}) => {
  const classes = useStyles();
  const userInfo = useContext(UserInfoCtx);

  const category = categories && categories.length > 0 ? categories[0] : null;
  const categoryLink = createCategoryLink(category);
  const expertLink = authorSlug ? `${DEFAULT_URL}/experts/${authorSlug}` : '';

  const [toggleFromWatchlist, toggleFromWatchlistLoading] = useToggleFromWatchlist(
    isInWatchlist,
    id,
  );

  return (
    <Box className={cx(classes.cardWrapper, wrapperClass)} data-testid={rest['data-testid']}>
      <Link to={link}>
        <Box className={classes.imageWrapper}>
          {previewUrl && (
            <>
              <IKImage
                className={classes.previewImg}
                path={previewUrl}
                alt={title}
                draggable={false}
                srcset={[{ width: 420 }, { width: 370 }, { width: 350 }, { width: 340 }]}
                sizes={`(max-width:${BREAKPOINTS_VALUES['sm']}px) 420px, (max-width: ${BREAKPOINTS_VALUES['md']}) 370px, (max-width:${BREAKPOINTS_VALUES['lg']}px) 350px, 340px`}
              />
              <Box className={classes.playBtnWrap}>
                <PlaySmallIcon className={classes.btn} color={colorsPalette.white} />
              </Box>
            </>
          )}
        </Box>
      </Link>
      {category && (
        <div className={classes.categoryWrapper}>
          <CategoryLabel name={category.title} wrapperClass={classes.catName} url={categoryLink} />
          {!!difficulty && <DifficultyIcon difficulty={difficulty} />}
        </div>
      )}
      <Box className={classes.textWrapper}>
        <Link to={link}>
          <Typography className={classes.title}>{title}</Typography>
        </Link>
        <div className={classes.infoRow}>
          {(author || duration) && (
            <CardDurationInfo
              durationName={author}
              duration={secondsToHms(duration)}
              link={expertLink}
            />
          )}
          {userInfo && (
            <ToggleFromList
              disabled={toggleFromWatchlistLoading}
              isAdd={!isInWatchlist}
              onClick={toggleFromWatchlist}
              noBackground
            />
          )}
        </div>
      </Box>
    </Box>
  );
};

export default SideVideoCard;
